import { PetBreakdownReport } from 'model/ClientAndPetsReport';
import { PetBreakdownReportDto } from './PetBreakdownReportDto';

export const convertToPetBreakdownReport = (dto: PetBreakdownReportDto): PetBreakdownReport => {
    return {
        meta: {
            page: Number(dto?.meta?.page ?? 1),
            perPage: Number(dto?.meta?.per_page ?? 10),
            totalCount: Number(dto?.meta?.total_count ?? 0),
            totalPages: Number(dto?.meta?.total_pages ?? 0)
        },
        pets: (dto?.pets || []).map(item => ({
            petType: item.pet_type,
            petBreed: item.pet_breed,
            totalBookings: item.total_bookings,
            netSales: item.net_sales,
            avgTicket: item.avg_ticket
        }))
    };
};
